import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../assets/mainwheel.gif'


const _hoisted_1 = {
  class: "contents s_intro",
  s_intro: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.animatedText, (char, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: index,
          style: _normalizeStyle({ animationDelay: `${index * 0.1}s` })
        }, _toDisplayString(char), 5))
      }), 128)),
      _cache[0] || (_cache[0] = _createTextVNode("TAKEOUT?"))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("b", null, [
      _createTextVNode("Who ordered a resume?"),
      _createElementVNode("br"),
      _createTextVNode(" 이력서 시키신 분?")
    ], -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "introgif" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "움직이는 gif"
      })
    ], -1))
  ]))
}